import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  ContactMessagePayload,
  ContactMessageResponse,
} from "../../interface/public.interface";

class ContactService {
  /**
   * 📩 SEND CONTACT MESSAGE
   */
  async sendContactMessage(
    payload: ContactMessagePayload
  ): Promise<ContactMessageResponse> {
    try {
      const response = await apiClient.post<ContactMessageResponse>(
        env.CONTACT.PUBLIC,
        payload
      );

      return response.data;
    } catch (error: any) {
      /**
       * ⚠️ Validation error (422)
       */
      if (error?.response?.status === 422) {
        throw {
          type: "validation",
          errors: error.response.data.errors,
        };
      }

      /**
       * ⚠️ Server / network error
       */
      throw {
        type: "server",
        message:
          error?.response?.data?.message ||
          "Une erreur est survenue lors de l'envoi du message",
      };
    }
  }
}

export const publicContactService = new ContactService();